import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {
  title = 'יצאנו לדרך';
  captchaUrl:string = 'https://pre-www5.tel-aviv.gov.il/TlvServices/CaptchaServices/';
  
}
